<fas-services-table class="table-height" scrollHeight="flex"
  [value]="categoriesList"
  [rows]="currentRows"
  [columns]="categoryColumns"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  [first]="currentFirst"
  [paginator]="true"
  [showCheckbox]="false"
  [loading]="isLoading"
  (pageChange)="setCurrentPosition($event)"
  [showCurrentPageReport]="true"
  [showFooterPageReport]="false"
  [isOutlineHeadlight]="true"
  [showSearch]="true"
  searchPlaceholder="Szukaj działu..."
  [dropdownFilters]="dropdownFilters"
  (filtersChange)="onFiltersChange($event)"
  [rowClickFunction]="onRowTap"
  >
</fas-services-table>

<app-category-details
  [(detailsControl)]="detailsControl"
  [category]="selectedCategory"
  [categoryList]="originalCategoriesList"
  [categoryIndex]="categoryIndex"
  (refreshCategories)="refreshCategories()">
</app-category-details>
